import type { FunctionComponent } from 'react';
import { lazy } from 'react';

import { Suspended } from '../../../suspended/Suspended';

const LazyHistoryContainerConnected = lazy(() => import('../../../history/container/HistoryContainerConnected'));

export const NavPageHistoryConnected: FunctionComponent = () => (
  <Suspended>
    <LazyHistoryContainerConnected inNavDrawer />
  </Suspended>
);
